// extracted by mini-css-extract-plugin
export default {"skillsRow":"Skills_skillsRow__Y9kPr","skill":"Skills_skill__AxCyB"};